import { render, staticRenderFns } from "./GoogleBusinessChannels.vue?vue&type=template&id=ad9d53f4&scoped=true"
import script from "./GoogleBusinessChannels.vue?vue&type=script&lang=js"
export * from "./GoogleBusinessChannels.vue?vue&type=script&lang=js"
import style0 from "./GoogleBusinessChannels.vue?vue&type=style&index=0&id=ad9d53f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad9d53f4",
  null
  
)

export default component.exports